import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import {
  getCategorySelectOptions,
  getSystemModelsByCategory,
} from '../../../data/systemModels';
import { FAVORITE_TYPE_SYSTEM } from '../../../services/favoriteModelsService';
import { useFavoriteModels } from '../../../context/FavoriteModelsContext';
import ModelLibraryCardShell from './ModelLibraryCardShell';
import ModelListItem from './ModelListItem';

const PREVIEW_LIMIT = 10;

const SystemModelsCard = () => {
  const navigate = useNavigate();
  const { isFavorite, toggleFavorite, isSaving } = useFavoriteModels();
  const categoryOptions = useMemo(() => getCategorySelectOptions(), []);
  const [selectedCategory, setSelectedCategory] = useState(
    categoryOptions[0]?.value ?? 'corretores'
  );

  const visibleModels = useMemo(
    () => getSystemModelsByCategory(selectedCategory).slice(0, PREVIEW_LIMIT),
    [selectedCategory]
  );

  const handleOpenModel = (modelId) => {
    navigate(
      `/contract-generator?document_id=${encodeURIComponent(String(modelId))}`
    );
  };

  return (
    <ModelLibraryCardShell accent>
      <div className="flex items-center gap-2.5 mb-3">
        <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-primary/10 shrink-0">
          <Icon name="FileText" size={18} className="text-primary" />
        </div>
        <div className="min-w-0">
          <h2 className="text-base font-semibold text-foreground tracking-tight truncate">
            Modelos do Sistema
          </h2>
          <p className="text-xs text-muted-foreground truncate">
            Modelos prontos por categoria
          </p>
        </div>
      </div>

      <Select
        label="Categoria"
        placeholder="Selecione..."
        options={categoryOptions}
        value={selectedCategory}
        onChange={setSelectedCategory}
        className="mb-3"
      />

      <div className="flex-1 min-h-0 overflow-y-auto space-y-1 mb-3 pr-0.5">
        {visibleModels.length === 0 ? (
          <p className="text-xs text-muted-foreground py-6 text-center">
            Nenhum modelo para esta categoria.
          </p>
        ) : (
          visibleModels.map((model) => (
            <ModelListItem
              key={model.id}
              label={model.name}
              onClick={() => handleOpenModel(model.id)}
              isFavorite={isFavorite(FAVORITE_TYPE_SYSTEM, model.id)}
              favoriteDisabled={isSaving}
              onToggleFavorite={() =>
                toggleFavorite(FAVORITE_TYPE_SYSTEM, model.id)
              }
            />
          ))
        )}
      </div>

      <Button
        type="button"
        variant="outline"
        size="sm"
        fullWidth
        onClick={() => navigate('/system-models')}
      >
        Ver Todos
      </Button>
    </ModelLibraryCardShell>
  );
};

export default SystemModelsCard;
